import { memo } from "react";
import { Box } from "@mui/material";

import { useEventManagerContext } from "../context/eventContext";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

import AppContentWrapper from "../../../2_ksbHub/components/AppContentWrapper";

import EventManagerMain from "./EventManagerMain";

import useEventActions from "../hooks/useEventActions";
import useEventLock from "../hooks/useEventLock";
import useEventTemplates from "../hooks/useEventTemplates";

import useEventManagerController from "../hooks/useEventManagerController";
import EventManagerDialogs from "./dialogs/EventManagerDialogs";
import EventManagerAlerts from "./utils/EventManagerAlerts";
import EventManagerActions from "./utils/EventManagerActions";

function EventManagerContent({ viewMode, dialogs }) {
  const { isTeacherView } = useAppContext();

  const {
    selectedSchoolyear,
    setEvents,
    selectedEvent,
    setSelectedEvent,
    shifts,
    isAnEventManagerAdmin,
  } = useEventManagerContext();

  /* ---------------- HOOKS ---------------- */
  const templates = useEventTemplates();
  const { showUnlockedToast, setShowUnlockedToast } = useEventLock();
  const actions = useEventActions();

  const controller = useEventManagerController({
    selectedSchoolyear,
    setEvents,
    setSelectedEvent,
    ...actions,
  });

  /* ---------------- RENDER ---------------- */

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      {/* CONTENT */}
      <AppContentWrapper padding={false} gap={1.2} scrollable={false}>
        <EventManagerMain
          viewMode={viewMode}
          dialogs={dialogs}
          actions={actions}
        />

        {isAnEventManagerAdmin && !isTeacherView && (
          <EventManagerActions
            isAnEventManagerAdmin={isAnEventManagerAdmin}
            selectedEvent={selectedEvent}
            actions={actions}
            dialogs={dialogs}
          />
        )}
      </AppContentWrapper>

      {/* DIALOGS */}
      <EventManagerDialogs
        dialogs={dialogs}
        actions={actions}
        controller={controller}
        templates={templates}
        selectedSchoolyear={selectedSchoolyear}
        shifts={shifts}
      />

      {/* ALERTS */}

      <EventManagerAlerts
        showUnlockedToast={showUnlockedToast}
        setShowUnlockedToast={setShowUnlockedToast}
        errorMessage={controller.errorMessage}
        setErrorMessage={controller.setErrorMessage}
      />
    </Box>
  );
}

export default memo(EventManagerContent);
